/* unplugin-vue-components disabled */import script from "./race-info.vue?vue&type=script&lang=jsx"
export * from "./race-info.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__